import { Box } from '@mui/material';
import logo from './assets/logo.png';

/**
 * The 联仓通 mark (two interlocking warehouses), the same artwork as the mini program icon and
 * its share cards. The square artwork is shown with rounded corners, like an app icon.
 */
export function BrandLogo({ size = 36 }: { size?: number }) {
  return (
    <Box
      component="img"
      src={logo}
      alt="联仓通"
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: 'block',
        borderRadius: `${Math.round(size * 0.26)}px`,
      }}
    />
  );
}
